var exports = {
  "kL": "VoiceControlBar.module__container___QzJRNE",
  "UD": "VoiceControlBar.module__buttonContainer___QzJRNE",
  "x6": "VoiceControlBar.module__button___QzJRNE",
  "QV": "VoiceControlBar.module__buttonMuted___QzJRNE",
  "rp": "VoiceControlBar.module__buttonUnmuted___QzJRNE",
  "Jt": "VoiceControlBar.module__buttonDeafened___QzJRNE",
  "Zj": "VoiceControlBar.module__buttonCameraOn___QzJRNE",
  "PQ": "VoiceControlBar.module__buttonCameraOff___QzJRNE",
  "bt": "VoiceControlBar.module__buttonScreenShareOn___QzJRNE",
  "fB": "VoiceControlBar.module__buttonScreenShareOff___QzJRNE",
  "_p": "VoiceControlBar.module__buttonMoreOptions___QzJRNE",
  "Zt": "VoiceControlBar.module__buttonDisconnect___QzJRNE",
  "Q1": "VoiceControlBar.module__buttonSeparator___QzJRNE",
  "Se": "VoiceControlBar.module__settingsButton___QzJRNE",
  "on": "VoiceControlBar.module__stopWatchingButton___QzJRNE",
  "Kk": "VoiceControlBar.module__icon___QzJRNE",
  "Bx": "VoiceControlBar.module__iconSmall___QzJRNE",
};

module.exports = exports;
